/* Publish by EComposer at 2026-10-25 06:09:17*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7yk3ev4w61j"]=  window.__ectimmers["ecom-7yk3ev4w61j"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-7yk3ev4w61j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yk3ev4w61j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whc8n2meoy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whc8n2meoy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c9bvz3xl186').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c9bvz3xl186', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1aciegoi6j6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1aciegoi6j6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yxcvdtxvwo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yxcvdtxvwo9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0uwvkdxw1go').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0uwvkdxw1go', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}